export default __webpack_public_path__ + "static/media/sport-objects.spritesheet@3x.bcd806d7.png";